import { generateCodeFrame } from "vue-template-compiler";

export class User {
    salarie_id;
    user_id;
    prenom = "demo";
    nom = "demo";
    mail;
    password = "";
    sexe = "";
    age = "";
    taille = "";
    poids = "";
    metier = null;
    liste_Metier = "";
    role = "";
    niveau = "";
    valid = "false";
    nom_entreprise;
    coach = true;
    cI = null;
    douleurs = null;
    dateCGU = null;

    constructor(arrays = null) {
        if (arrays !== null) {
            for (let attribut in arrays[0]) {
                let valeur = arrays[0][attribut];
                if (attribut == 'id') {
                    this.salarie_id = valeur;
                } else if (attribut == 'prenom') {
                    this.prenom = valeur;
                } else if (attribut == 'nom') {
                    this.nom = valeur;
                } else if (attribut == 'sexe') {
                    if (valeur == 0) {
                        this.sexe = 'femme';
                    } else {
                        this.sexe = 'homme';
                    }
                } else if (attribut == 'age') {
                    this.age = valeur;
                } else if (attribut == 'taille') {
                    this.taille = valeur;
                } else if (attribut == 'poids') {
                    this.poids = valeur;
                } else if (attribut == 'mail') {
                    this.mail = valeur;
                } else if (attribut == 'metier') {
                    this.metier = valeur;
                } else if (attribut == 'liste_Metier') {
                    this.liste_Metier = valeur;
                } else if (attribut == 'niveau') {
                    this.niveau = valeur;
                } else if (attribut == 'douleurs') {
                    this.douleurs = valeur;
                } else if (attribut == 'contre_Indications') {
                    if (attribut !== null && attribut !== undefined) {
                        this.cI = JSON.parse(valeur);
                    }
                } else if (attribut == 'nom_entreprise') {
                    this.nom_entreprise = valeur.toUpperCase();
                } else if (attribut == 'coach') {
                    if (valeur == true) {
                        this.coach = true;
                    } else {
                        this.coach = false;
                    }
                } else if (attribut == 'dateCGU') {
                    this.dateCGU = valeur;
                }
            }
            for (let attribut in arrays[1]) {
                let valeur = arrays[1][attribut];
                if (attribut == 'id') {
                    this.user_id = valeur;
                }
            }
        }
    }


    jsonSend() {
        let arrayUser = { mail: this.mail, password: this.password };
        return JSON.stringify(arrayUser);
    }


}


// WEBPACK FOOTER //
// ./src/controller/user.js